"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.settings.title': '聊天设置',
    'chat.settings.media_generation': '媒体生成',
    'chat.settings.image_model': '图像模型',
    'chat.settings.video_model': '视频模型',
    'chat.settings.voice.label': '语音',
    'chat.settings.chat_learning.label': '从聊天对话中学习用户信息',
    'chat.settings.chat_learning.description': '系统将不时分析您的对话，并根据您与系统交互的方式调整其回应风格',
    'chat.settings.enable_ai_assistant.label': '启用AI助手',
    'chat.settings.enable_ai_assistant.description': '启用AI助手以在对话期间提供智能建议和帮助',
    'chat.settings.enable_ai_assistant.disabled_tooltip': '您当前的计划无法使用AI助手。请升级以访问此功能。',
    'chat.settings.save': '保存',
    'chat.settings.saved': '设置保存成功',
    'chat.settings.ai_parameters': 'AI参数',
    'chat.settings.temperature.label': '温度',
    'chat.settings.temperature.description': '控制AI回应中的随机性。较低的值使回应更集中和确定性，较高的值使回应更有创意和多样化。',
    'chat.settings.temperature.min_label': '严格',
    'chat.settings.temperature.max_label': '创意',
    'chat.settings.assistance_setup': '助手设置',
    'chat.settings.max_tokens.label': '回复长度',
    'chat.settings.max_tokens.description': '控制AI回复的最大长度。默认使用模型设置，其他选项限制回复长度。',
    'chat.settings.max_tokens.default': '默认（模型设置）',
    'chat.settings.max_tokens.short': '短',
    'chat.settings.max_tokens.medium': '中',
    'chat.settings.max_tokens.long': '长',
    'chat.settings.extended_context.label': '扩展上下文',
    'chat.settings.extended_context.description': '启用扩展上下文模式以保持更长的对话记忆和更好地理解先前的消息',
    'chat.settings.thinking.label': '启用思考',
    'chat.settings.thinking.description': '在生成响应期间显示AI推理和思考过程',
};
